module.exports = __webpack_public_path__ + "static/img/epic.be3554cb.png";